/**
 * The `New` badge that announces the resource access grants GA, shown on the
 * Entitlements side-nav item and on the Access grants tab itself.
 *
 * Time-boxed on purpose. The flag that used to gate these surfaces is gone, so
 * without an expiry the badge would sit in the nav permanently and stop meaning
 * anything. Two weeks from the GA date.
 *
 * The badge is the only thing that expires — the tab and the nav item are
 * permanent, so tab indices do not change when this flips.
 */
export const ACCESS_GRANTS_NEW_BADGE_UNTIL = '2026-09-03';

/**
 * Whether the announcement badge should still render. Compared at UTC midnight,
 * so it disappears mid-morning for AU users rather than at their local
 * midnight; not worth a timezone dependency for a cosmetic badge.
 *
 * `now` is injectable so the boundary can be exercised without faking clocks.
 */
export function isAccessGrantsNewBadgeVisible(now: Date = new Date()): boolean {
  return (
    now.getTime() < Date.parse(`${ACCESS_GRANTS_NEW_BADGE_UNTIL}T00:00:00Z`)
  );
}
